module.exports = __webpack_public_path__ + "static/media/app-store.813d8bbd.png";